const defenceReportInit = () => {
    const defenceReportEl = document.querySelector('.s-defence-report');

    if (defenceReportEl) {
        const keyTouchpoints = defenceReportEl.querySelector('.key-touchpoints');
        const keyTouchpointsLi = keyTouchpoints.querySelectorAll('li');
        keyTouchpointsLi.forEach((li, i) => {
            li.classList.add('has-reveal');
            li.style.setProperty('--delay', `${i * 0.5}s`);
        });
        /**
         * @param {IntersectionObserverEntry[]} entries
         */
        const keyTouchpointsAnimateCb = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    keyTouchpointsLi.forEach(li => {
                        li.classList.add('animate-reveal');
                    });
                }
            });
        };
        const keyTouchpointsObserverOptions = { threshold: 0.5 };
        const keyTouchpointsObserver = new IntersectionObserver(
            keyTouchpointsAnimateCb,
            keyTouchpointsObserverOptions
        );
        keyTouchpointsObserver.observe(keyTouchpoints);

        const typewriters = defenceReportEl.querySelectorAll('.js-typewriter');
        typewriters.forEach(tw => {
            const twText = tw.textContent;
            const hiddenTextSpan = document.createElement('span');
            tw.textContent = '';
            hiddenTextSpan.textContent = twText;
            hiddenTextSpan.style.setProperty('color', 'transparent');
            tw.appendChild(hiddenTextSpan);

            window.addEventListener('load', () => {
                const typewriter = (str, i) => {
                    if (i < str.length) {
                        tw.textContent = twText.slice(0, i + 1);
                        hiddenTextSpan.textContent = twText.slice(i + 1);
                        tw.appendChild(hiddenTextSpan);
                        // tw.textContent += twText.charAt(i);
                        setTimeout(() => typewriter(str, i + 1), 80);
                    }
                };
                const twObserverCb = entries => {
                    entries.forEach(entry => {
                        if (
                            entry.isIntersecting && !tw.classList.contains('typed-out')
                        ) {
                            tw.classList.add('typed-out');
                            // tw.textContent = '';
                            typewriter(twText, 0);
                        }
                    });
                };
                const twObserver = new IntersectionObserver(twObserverCb);
                twObserver.observe(tw);
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', defenceReportInit);
